export default {"src":"/_next/static/media/whypod-icon3.44a1e7c9.svg","height":48,"width":49};